import { useEtapaTiposObra } from "./use-etapa-tipos-obra";
import { EtapaTiposObraView } from "./view-etapa-tipos-obra";

export function EtapaTiposObra() {
  const vm = useEtapaTiposObra();

  return <EtapaTiposObraView {...vm} />;
}

export type * from "./types-etapa-tipos-obra";
